import { Link } from "react-router-dom"
import { ButtonLight, EyebrowLabel } from "../lib/shared"
import { Seo } from "../lib/seo"

const HELPFUL = [
  { l: "Our work", to: "/work" },
  { l: "Government", to: "/government" },
  { l: "About us", to: "/about" },
  { l: "Contact", to: "/contact" },
]

export default function NotFound() {
  return (
    <section className="grid min-h-[80vh] items-center bg-ink text-white lg:place-items-center">
      <Seo
        title="Page not found"
        description="The page you are looking for does not exist or has moved."
        noindex
      />
      <div className="px-6 pb-16 pt-40 lg:text-center">
        <div className="flex lg:justify-center">
          <EyebrowLabel light>Error 404</EyebrowLabel>
        </div>
        <h1 className="mt-6 text-[clamp(2.8rem,7vw,5rem)] font-black leading-none tracking-[-0.04em]">
          This page doesn&rsquo;t exist
        </h1>
        <p className="mt-6 max-w-md lg:mx-auto text-[16px] leading-[1.7] text-neutral-400">
          It may have moved, or the link might be wrong. One of these should
          get you where you were going.
        </p>
        <div className="mt-10 flex lg:justify-center">
          <ButtonLight to="/">Back to the homepage</ButtonLight>
        </div>
        <ul className="mt-10 flex flex-wrap gap-x-8 gap-y-3 lg:justify-center">
          {HELPFUL.map((h) => (
            <li key={h.to}>
              <Link
                to={h.to}
                className="inline-block py-1.5 text-[14px] font-medium text-neutral-300 underline-offset-4 transition-colors hover:text-white hover:underline"
              >
                {h.l}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}
